import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import { resolvePostLoginRoute } from '../utils/resolvePostLoginRoute';

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    async function check() {
      try {
        const authToken = localStorage.getItem('authToken');
        const meRes = await fetch(`${API_BASE_URL}/auth/me`, {
          credentials: 'include',
          headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
        });

        if (meRes.status === 401) return navigate('/giris-yap');
        const user = await meRes.json();
        if (!user) return navigate('/giris-yap');

        const route = await resolvePostLoginRoute();
        return navigate(route);
      } catch (err) {
        console.error('Auth callback error', err);
        return navigate('/');
      }
    }

    check();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div>Oturum doğrulanıyor, yönlendiriliyorsunuz...</div>
    </div>
  );
}
